export default __webpack_public_path__ + "static/media/zero-trust.114671b7.svg";